import { render } from "./DynamicSplitButton.vue?vue&type=template&id=7200a2f6&ts=true"
import script from "./DynamicSplitButton.vue?vue&type=script&lang=ts"
export * from "./DynamicSplitButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicSplitButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7200a2f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7200a2f6', __exports__)) {
    api.reload('7200a2f6', __exports__)
  }
  
  module.hot.accept("./DynamicSplitButton.vue?vue&type=template&id=7200a2f6&ts=true", () => {
    api.rerender('7200a2f6', render)
  })

}


export default __exports__